<div class="card">
  <div class="flex items-center gap-3">
    <h5 class="font-bold">Contrato</h5>
    <div class="w-fit">
      <app-tag-status
        [status]="contractTag().status"
        [text]="contractTag().text"
      ></app-tag-status>
    </div>
    @if (contractSigned()) {
      <p>
        Assinado em:
        {{ order()?.contract!.signedAt | date: "dd/MM/yyyy HH:mm" }}
      </p>
    }
    @if (canSendReminder()) {
      <p-button
        type="button"
        label="Enviar lembrete"
        icon="ph ph-envelope-simple"
        severity="secondary"
        rounded
        class="btn-secondary-outline ml-auto"
        (click)="openReminderDialog()"
      ></p-button>
    }
  </div>

  @if (contractViewerUrl(); as viewerUrl) {
    <div class="w-full mt-5">
      <iframe title="Contract" [src]="viewerUrl" class="w-full h-120"></iframe>
    </div>
  }
</div>

<p-dialog
  [visible]="reminderDialogVisible()"
  (visibleChange)="closeReminderDialog()"
  [modal]="true"
  [dismissableMask]="false"
  [closable]="!sendingReminder()"
  [closeOnEscape]="!sendingReminder()"
  [draggable]="false"
  [style]="{ width: '480px' }"
  [breakpoints]="{ '520px': 'calc(100vw - 2rem)' }"
  header="Enviar lembrete de assinatura"
>
  <p>
    Um e-mail com o link para assinar o contrato será enviado ao cliente
    <span class="font-bold">{{ order()?.customer?.fullName }}</span
    >.
  </p>

  <div class="flex justify-end gap-2 mt-5">
    <p-button
      type="button"
      label="Voltar"
      severity="secondary"
      rounded
      class="btn-secondary-outline"
      [disabled]="sendingReminder()"
      (onClick)="closeReminderDialog()"
    ></p-button>
    <p-button
      type="button"
      label="Enviar lembrete"
      rounded
      [loading]="sendingReminder()"
      [disabled]="sendingReminder()"
      (onClick)="sendReminder()"
    ></p-button>
  </div>
</p-dialog>
